<template>
  <div>
    <div class="card card-default mb-4">
      <h4 class="card-header">
        <i
          v-if="overdue"
          class="fa fa-exclamation-triangle text-warning" />
        Customer {{ customerDetails.fullName }}
      </h4>
      <div class="card-body">
        <p
          class="alert alert-warning"
          v-if="overdue">
          Customer account review is overdue
        </p>
        <h6>
          <i class="fas fa-user fa-fw" /> <b>User:</b> {{ customerDetails.dropdownLabel }}
        </h6>
        <br />
        <p class="mb-1">
          <i class="fas fa-at fa-fw" /> <b>Email:</b> {{ customerDetails.email }}
        </p>
        <p class="mb-1">
          <i class="fas fa-map-marker fa-fw" /> <b>Address:</b> {{ customerDetails.address ? customerDetails.address : 'N/A' }}
        </p>
        <p class="mb-1">
          <i class="fas fa-mobile-alt fa-fw" /> <b>Mobile Phone:</b> {{ customerDetails.mobilePhone }}
        </p>
        <p class="mb-1">
        <p class="mb-1">
          <i class="fas fa-phone fa-fw" /> <b>Business Phone:</b> {{ customerDetails.workPhone ? customerDetails.workPhone : 'N/A' }}
        </p>
        <p class="mb-1">
          <i class="fas fa-clock fa-fw" /> <b>Registered On:</b> {{ customerDetails.createdAt | date_time_format }}
        </p>
        <br />
        <template v-if="customerDetails.Company">
          <h6>
            <i class="fas fa-building fa-fw" /> <b>Company Trading As:</b> {{ customerDetails.Company.name ? customerDetails.Company.name : 'N/A' }}
          </h6>
          <p class="mb-1">
            <i class="fas fa-building fa-fw" /> <b>Legal Entity:</b> {{ customerDetails.Company.legalEntity ? customerDetails.Company.legalEntity : 'N/A' }}
          </p>
          <br />
          <p class="mb-1">
            <i class="fas fa-map-marker fa-fw" /> <b>Address:</b> {{ customerDetails.Company.address ? customerDetails.Company.address : 'N/A' }}
          </p>
          <p class="mb-1">
            <i class="fas fa-phone fa-fw" /> <b>Contact Number:</b> {{ customerDetails.Company.phone ? customerDetails.Company.phone : 'N/A' }}
          </p>
          <p class="mb-1">
            <i class="fas fa-building fa-fw" /> <b>ABN:</b> {{ customerDetails.Company.abn ? customerDetails.Company.abn : 'N/A' }}
          </p>
          <p class="mb-1">
            <i class="fas fa-globe fa-fw" /> <b>Website:</b>
            <template v-if="customerDetails.Company.webAddress">
              <a :href="customerDetails.Company.webAddress">{{ customerDetails.Company.webAddress }}</a>
            </template>
            <template v-else>
              N/A
            </template>

          </p>
        </template>
        <template v-else>
            <h6>
              <i class="fas fa-mobile-alt fa-fw" /> <b>Company:</b> N/A
            </h6>
        </template>
      </div>
      <div class="card-footer">
        <button class="my-1 btn btn-success" @click="review()">
          <i class="fa fa-share"></i> Review
        </button>
      </div>
    </div>
  </div>
</template>


<script>
  import DownloadInput from '@/components/inputs/DownloadInput'
  import {
    REVIEW_CUSTOMER
    } from '@/vuex/types'
  export default {
    name: 'WaitingCustomerCard',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      DownloadInput
    },
    computed: {
      customerDetails () {
        return {
          ...this.object
        }
      },
      overdue () {
        let registeredDate = new Date(this.object.createdAt)
        let currDate = new Date()
        let diff = Math.abs(currDate.getTime() - registeredDate.getTime()) / 36e5
        return diff > 48
      }
    },
    methods: {
      async review () {
        await this.$store.dispatch(REVIEW_CUSTOMER, this.customerDetails.uuid)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/cards/Customer.vue